import _get from 'lodash/get';

import { Base } from '@/models';
import { toCamelCase } from '@/utilities';

export class JobUpdate extends Base {
  public description: string;
  public date: string;
  public photos: string[];


  /**
   * Constructor initialises the variables from the class Fee
   * @param data - the data to construct a type with all properties of <Fee>
   */
  public constructor(data?: Partial<JobUpdate>) {
    super(data);
    data = toCamelCase(data);
    this.description = _get(data, 'description', '');
    this.date = _get(data, 'date', '');
    this.photos = _get(data, 'photos', []);
  }
}
